// companyFooter.js — the one-line legal footer on every client quote
// (Automotive and Industrial): trading name, company and VAT numbers,
// registered office and contact details. Values come from Company Settings
// (CompanySettings sheet tab) when they're stored there; the fallbacks below
// are used for anything missing, or if the settings can't be read.

import { fetchCompanySettings } from "./quoteLogger";

const FALLBACK = {
  tradingAs: "Sublime Precision Cleaning",
  companyName: "Way Out West Ltd",
  companyNumber: "14772088",
  vatNumber: "429689047",
  registeredAddress: "The Old School, Stennack, St Ives, TR26 1QU",
  phoneNumber: "01736 804118",
  companyEmail: "hello@sublimeprecision.co.uk",
};

const esc = s => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// Company Settings, or null if they can't be read (never throws).
export async function loadCompanySettings() {
  try { return await fetchCompanySettings(); } catch (e) { return null; }
}

// "X is a trading name of Y · Company No. … · VAT No. … · Registered office: … · phone · email", HTML-escaped.
export function legalFooterLine(settings) {
  const v = k => String(settings?.[k] || "").trim() || FALLBACK[k];
  const address = v("registeredAddress").split(/\s*\n\s*/).filter(Boolean).join(", ");
  return [
    `${v("tradingAs")} is a trading name of ${v("companyName")}`,
    `Company No. ${v("companyNumber")}`,
    `VAT No. ${v("vatNumber")}`,
    `Registered office: ${address}`,
    v("phoneNumber"),
    v("companyEmail"),
  ].map(esc).join(" · ");
}

// The footer line as a block for the quote templates.
export function legalFooterHTML(settings) {
  return `<div style="margin-top:10px;font-size:9px;line-height:1.5;color:#aab0ba;text-align:center;">${legalFooterLine(settings)}</div>`;
}
